import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default class GallerySlider {
	
	constructor(el) {

		this.el = el;

		this.initGallerySliders(el);

	}

	initGallerySliders(elm){

		const baseConfig = {  
			modules         : [ Pagination, Navigation ], 		
			slidesPerView   : 'auto',			
			centeredSlides	: true,
			loop            : true,
			spaceBetween    : 12,
			autoHeight      : false,
			navigation        : {
				nextEl      : elm.querySelector('.swiper-button-next'),
				prevEl      : elm.querySelector('.swiper-button-prev'),
			}, 
			breakpoints       : {			
				10 : {					    
					slidesPerView   : 'auto',				    
					spaceBetween    : 8,					
			  	},				
				320 : {					    
					slidesPerView   : 'auto',				    
					spaceBetween    : 8,					
			  	},			
				480 : {					    
					slidesPerView   : 'auto',				    
					spaceBetween    : 12,					
			  	},
			},
		};

		const swiper = new Swiper( elm.querySelector('.swiper'), baseConfig); 

	}

}